import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    add_size_item,
    remove_size_item,
    text_field_change,
} from "../../redux/actions";

export const Sizes = () => {
    const dispatch = useDispatch();
    let sizes = useSelector((state) => state.app.fields.sizes);
    let sizesError = useSelector((state) => state.app.fields.sizesError);
    let sizesUpdate = useSelector((state) => state.app.fields.sizesUpdate);

    return (
        <React.Fragment>
            <div className="front-calc__sizes">
                {sizesUpdate}
                {sizes.length > 0 &&
                    sizes.map((item, index) => {
                        let length = parseInt(item.sizeLength.value);
                        let width = parseInt(item.sizeWidth.value);
                        let height = parseInt(item.sizeHeight.value);
                        let weight = parseInt(item.sizeWeight.value);
                        let counter = parseInt(item.sizeCounter.value);
                        let volume = 0;
                        let empty = true;
                        if (length > 0 && width > 0 && height > 0) {
                            volume = (length * width * height) / 1000000;
                        }
                        if (
                            length > 0 &&
                            width > 0 &&
                            height > 0 &&
                            weight > 0 &&
                            counter > 0
                        ) {
                            empty = false;
                        }
                        return (
                            <div
                                className={
                                    "front-calc__size" +
                                    " " +
                                    (empty && sizesError ? "error" : "")
                                }
                                key={index}
                            >
                                <div className="front-calc__size_col">
                                    <label>
                                        Длина, <br />
                                        см
                                    </label>
                                    <input
                                        type="number"
                                        id="size_length"
                                        className="text-input"
                                        name="size_length"
                                        autoComplete="off"
                                        placeholder="0"
                                        min="0"
                                        value={length}
                                        onChange={(e) =>
                                            dispatch(
                                                text_field_change(
                                                    "size_length",
                                                    e.target.value,
                                                    index,
                                                ),
                                            )
                                        }
                                    />
                                </div>
                                <div className="front-calc__size_icon">
                                    <img
                                        src="https://scs-aero.ru/wp-content/themes/scs2022/images/icon-times.svg"
                                        alt=""
                                        title=""
                                    />
                                </div>
                                <div className="front-calc__size_col">
                                    <label>
                                        Ширина, <br />
                                        см
                                    </label>
                                    <input
                                        type="number"
                                        id="size_width"
                                        className="text-input"
                                        name="size_width"
                                        autoComplete="off"
                                        placeholder="0"
                                        min="0"
                                        value={width}
                                        onChange={(e) =>
                                            dispatch(
                                                text_field_change(
                                                    "size_width",
                                                    e.target.value,
                                                    index,
                                                ),
                                            )
                                        }
                                    />
                                </div>
                                <div className="front-calc__size_icon">
                                    <img
                                        src="https://scs-aero.ru/wp-content/themes/scs2022/images/icon-times.svg"
                                        alt=""
                                        title=""
                                    />
                                </div>
                                <div className="front-calc__size_col">
                                    <label>
                                        Высота, <br />
                                        см
                                    </label>
                                    <input
                                        type="number"
                                        id="size_height"
                                        className="text-input"
                                        name="size_height"
                                        autoComplete="off"
                                        placeholder="0"
                                        min="0"
                                        value={height}
                                        onChange={(e) =>
                                            dispatch(
                                                text_field_change(
                                                    "size_height",
                                                    e.target.value,
                                                    index,
                                                ),
                                            )
                                        }
                                    />
                                </div>
                                <div className="front-calc__size_icon">
                                    <img
                                        src="https://scs-aero.ru/wp-content/themes/scs2022/images/icon-equals.svg"
                                        alt=""
                                        title=""
                                    />
                                </div>
                                <div className="front-calc__size_col">
                                    <label>
                                        Объем, <br />
                                        м3
                                    </label>
                                    <div className="size_volume front-calc__input">
                                        {parseFloat(volume).toFixed(3)}
                                    </div>
                                </div>
                                <div className="front-calc__size_col front-calc__size_weight ml">
                                    <label>Вес места, кг</label>
                                    <input
                                        type="number"
                                        id="size_weight"
                                        className="text-input"
                                        name="size_weight"
                                        autoComplete="off"
                                        placeholder="0"
                                        min="0"
                                        value={weight}
                                        onChange={(e) =>
                                            dispatch(
                                                text_field_change(
                                                    "size_weight",
                                                    e.target.value,
                                                    index,
                                                ),
                                            )
                                        }
                                    />
                                </div>
                                <div className="front-calc__size_counter">
                                    <label>Одинаковые места</label>
                                    <div className="front-calc__counter">
                                        <div
                                            className="front-calc__counter_minus"
                                            onClick={(e) =>
                                                dispatch(
                                                    text_field_change(
                                                        "size_counter",
                                                        counter > 1
                                                            ? counter - 1
                                                            : 1,
                                                        index,
                                                    ),
                                                )
                                            }
                                        />
                                        <input
                                            type="text"
                                            id="size_counter"
                                            className="front-calc__counter_input"
                                            name="size_counter"
                                            autoComplete="off"
                                            value={counter}
                                            onChange={(e) =>
                                                dispatch(
                                                    text_field_change(
                                                        "size_counter",
                                                        e.target.value,
                                                        index,
                                                    ),
                                                )
                                            }
                                        />
                                        <div
                                            className="front-calc__counter_plus"
                                            onClick={(e) =>
                                                dispatch(
                                                    text_field_change(
                                                        "size_counter",
                                                        counter + 1,
                                                        index,
                                                    ),
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                <div
                                    className="front-calc__size_remove"
                                    onClick={() =>
                                        dispatch(remove_size_item(index))
                                    }
                                />
                            </div>
                        );
                    })}
            </div>

            <div
                className="front-calc__btn_size_add"
                onClick={() => dispatch(add_size_item())}
            >
                <img
                    src="https://scs-aero.ru/wp-content/themes/scs2022/images/icon-plus-2.svg"
                    alt=""
                    title=""
                />
                <span>Добавить грузовое место</span>
            </div>
        </React.Fragment>
    );
};
